import { render, staticRenderFns } from "./0004.vue?vue&type=template&id=2ab5a695&scoped=true&"
import script from "./0004.vue?vue&type=script&lang=js&"
export * from "./0004.vue?vue&type=script&lang=js&"
import style0 from "./0004.vue?vue&type=style&index=0&id=2ab5a695&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5a695",
  null
  
)

export default component.exports